<template>
    <div>
        <left-column
            class="stepAddress"
            :style="{backgroundImage:bgImg}"
        >

        </left-column>
        <right-column>
            <h2>{{$t('step_address.heading')}}</h2>
            <p>{{$t('step_address.subheading')}}</p>
            <gmap-autocomplete
                ref="gMap"
                class="wg-autocomplete"
                :select-first-on-enter="true"
                :componentRestrictions="{country: wgCalc.countries || ['se']}"
                :types="['address']"
                :options="{fields: ['geometry', 'formatted_address','address_components']}"
                @place_changed="selectAddress"
            >
                <template v-slot:input="slotProps">
                    <v-text-field
                        v-model="address"
                        outlined
                        rounded
                        :placeholder="$t('address')"
                        ref="input"
                        v-on:listeners="slotProps.listeners"
                        v-on:attrs="slotProps.attrs">
                    </v-text-field>
                </template>
            </gmap-autocomplete>
            <div ref="gMpapH" style="display: none" ></div>
        </right-column>
    </div>
</template>
<script>
import LeftColumn from "../LeftColumn";
import RightColumn from "../RightColumn";
import {gmapApi} from 'vue2-google-maps-withscopedautocomp';
import {getAddressStructure} from '@/helpers'
import steps from "./mixins/steps";
export const STEP_KEY = 'address'
export default {
    name: 'StepAddress',
    mixins:[steps],
    components: {
        LeftColumn,
        RightColumn
    },
    data() {
        return {
            bgImg: `url(${require('@/assets/bg/step_address_men.png')})`,
            address: this.$storage.state.summary.address.formatted ? this.$storage.state.summary.address.formatted : null,
            place:this.$storage.state.place || null
        }
    },

    computed: {
        google: gmapApi,
        isValid(){
            return this.place ? true : false;

        }
    },
    mounted() {

        if( !this.$storage.state.place && window.wgCalc.address) {
            this.$storage.showLoading();
            this.$gmapApiPromiseLazy().then((map) => {
                const request = {
                    query: window.wgCalc.address,
                    fields: ['place_id'],
                };
                const service = new this.google.maps.places.PlacesService(this.$refs.gMpapH);
                const that = this;
                service.findPlaceFromQuery(request, function(results, status) {
                    if (status === that.google.maps.places.PlacesServiceStatus.OK) {
                        let place_id=null;
                        if(results.length && (place_id = results[0].place_id)){
                            const request ={
                                placeId: place_id,
                                fields:  ['geometry', 'formatted_address','address_components'],
                            }
                            service.getDetails(request, function(results, status) {
                                if (status === that.google.maps.places.PlacesServiceStatus.OK) {
                                    that.place = results;
                                    that.applyNext();
                                }
                                that.$storage.hideLoading();
                            });
                        }
                    }else{
                        that.$storage.hideLoading();
                    }

                });

            });
        }

    },
    methods: {
        selectAddress(place) {

            this.address = place.formatted_address;
            this.$storage.state.place = this.place = place;

            //localStorage.setItem('selectedAddress',place.name);
            //localStorage.setItem('selectedLocation',JSON.stringify({lat:place.geometry.location.lat(),lng:place.geometry.location.lng()}));

        },
        applyNext() {
            if (this.$storage.state.passed.indexOf(STEP_KEY) <= 0) {
                this.$storage.state.passed.push(STEP_KEY);
            }

            this.$storage.state.polygon = null;
            this.$storage.state.summary.panels.amount = 0;
            this.$storage.state.summary.address.formatted = this.place.formatted_address;
            this.$storage.state.summary.address.lat = this.place.geometry.location.lat();
            this.$storage.state.summary.address.lng = this.place.geometry.location.lng();

            const address = getAddressStructure(this.place);
            this.$storage.state.form.address = address.street;
            this.$storage.state.form.zipcode = address.postcode;
            this.$storage.state.form.city = address.city;

            this.$storage.state.currentStep = this.$storage.state.steps[this.$storage.state.steps.indexOf(this.$storage.state.currentStep) + 1];
        }
    }

}
</script>
<style lang="scss">
.wg-autocomplete{
    .v-input__slot{
        background: #FFF !important;
        z-index: 10;
    }

}
.wgCalc{
    &LeftCol{
        @media only screen and (max-width: 755px){
            &.stepAddress{
                height: 400px;
            }
        }
    }
}
</style>
